import officeApiExecAsync from './infrastructure/office-api-exec-async'
import officeApiGetAsync from './infrastructure/office-api-get-async'

export async function officeApiMessage_FromGetAsync(): Promise<Office.EmailAddressDetails> {
  return officeApiGetAsync<Office.EmailAddressDetails>(
    '1.7',
    'from.getAsync',
    () => new Promise<Office.AsyncResult<Office.EmailAddressDetails>>((resolve) => Office.context.mailbox.item.from.getAsync(resolve)),
    null,
  )
}

export async function officeApiMessage_ToGetAsync(): Promise<Office.EmailAddressDetails[]> {
  return officeApiGetAsync<Office.EmailAddressDetails[]>(
    '1.1',
    'to.getAsync',
    () => new Promise<Office.AsyncResult<Office.EmailAddressDetails[]>>((resolve) => Office.context.mailbox.item.to.getAsync(resolve)),
    [],
  )
}

export async function officeApiMessage_ToAddAsync(emails: Office.EmailAddressDetails[]): Promise<boolean> {
  return officeApiExecAsync(
    '1.1',
    'to.addAsync',
    () => new Promise<Office.AsyncResult<void>>((resolve) => Office.context.mailbox.item.to.addAsync(emails, resolve)),
  )
}

export async function officeApiMessage_CcGetAsync(): Promise<Office.EmailAddressDetails[]> {
  return officeApiGetAsync<Office.EmailAddressDetails[]>(
    '1.1',
    'cc.getAsync',
    () => new Promise<Office.AsyncResult<Office.EmailAddressDetails[]>>((resolve) => Office.context.mailbox.item.cc.getAsync(resolve)),
    [],
  )
}

export async function officeApiMessage_CcAddAsync(emails: Office.EmailAddressDetails[]): Promise<boolean> {
  return officeApiExecAsync(
    '1.1',
    'cc.addAsync',
    () => new Promise<Office.AsyncResult<void>>((resolve) => Office.context.mailbox.item.cc.addAsync(emails, resolve)),
  )
}

export async function officeApiMessage_BccGetAsync(): Promise<Office.EmailAddressDetails[]> {
  return officeApiGetAsync<Office.EmailAddressDetails[]>(
    '1.1',
    'bcc.getAsync',
    () => new Promise<Office.AsyncResult<Office.EmailAddressDetails[]>>((resolve) => Office.context.mailbox.item.bcc.getAsync(resolve)),
    [],
  )
}

export async function officeApiMessage_BccAddAsync(emails: Office.EmailAddressDetails[]): Promise<boolean> {
  return officeApiExecAsync(
    '1.1',
    'bcc.addAsync',
    () => new Promise<Office.AsyncResult<void>>((resolve) => Office.context.mailbox.item.bcc.addAsync(emails, resolve)),
  )
}
